import { Box } from '@branch-messenger/willow-ui'
import { MessageQuestionCircle } from '@branch-messenger/willow-ui/icons'
import { useMediaQuery } from '@uidotdev/usehooks'

import { Alert, AlertBodyText } from '@/components/alert'
import { useOrg } from '@/selectors/organization'
import { mediaQueries } from '@/styles/media'

import { PayoutMethodContainer } from './styles'

export const NoPayoutMethod = () => {
  const {
    data: { orgName },
  } = useOrg()
  const isLargTabletAndDown = useMediaQuery(mediaQueries.largeTabletAndDown)
  const selectionText = isLargTabletAndDown
    ? 'by clicking the three dots above.'
    : 'below.'
  return (
    <PayoutMethodContainer>
      <Alert Icon={MessageQuestionCircle}>
        <Box $display="flex" $gap={1} $direction="column" $align="initial">
          <AlertBodyText $bold>No payment method set</AlertBodyText>
          <AlertBodyText>
            {`You're currently not set up to receive fast payouts from
                ${orgName}. If you'd like to get set up, make your
                selection ${selectionText}`}
          </AlertBodyText>
        </Box>
      </Alert>
    </PayoutMethodContainer>
  )
}
